import { getAllDemandesSaga } from './getAllDemandes'
import { getArchiveSaga } from './getArchive'
import { getDemandeSaga } from './getDemande'
import { addDemandeSaga } from './addDemande'
import { editDemandeSaga } from './editDemande'
import { verifCertifSaga } from './verifCertif'
import { transfertDemandeSaga } from './transfert'
import { updatePaySaga } from './updatePay'

const demandeSagas = [
    getDemandeSaga,
    getAllDemandesSaga,
    getArchiveSaga,
    addDemandeSaga,
    editDemandeSaga,
    verifCertifSaga,
    transfertDemandeSaga,
    updatePaySaga,
]

export default demandeSagas
